import React from 'react';
import { Link } from 'react-router-dom';
import ecommerceImg     from '../assets/ecommerce_blog.png';
import healthcareImg    from '../assets/healthcare_blog.png';
import financialImg     from '../assets/financial_blog.png';
import englishAIImg     from '../assets/EnglishAI_blog.png';
import defiImg          from '../assets/defi_blog.png';
import realEstateImg    from '../assets/realestate_blog.png';
import './B2B_Blog_Lists.css';

export default function B2B_Blog_Lists() {
  const placeholderCases = [
    { id: 'ecom',   title: 'E‑commerce Personalization', img: ecommerceImg },
    { id: 'health', title: 'Healthcare Chatbots',          img: healthcareImg },
    { id: 'finance',title: 'Financial Analytics',          img: financialImg },
  ];
  const actualCases = [
    {
      id:       'english-ai',
      title:    'AI‑Driven Practice and Feedback System for Enhanced Language Learning',
      subtitle: 'From Real‑Time Exam Simulation to Personalized AI Feedback and Progress Tracking',
      date:     '2025.04.10',
      img:      englishAIImg,
      link:     '/b2b/use-cases/english-ai'
    },
    {
      id:       'defi',
      title:    'Seamless Command Recognition and Real‑Time On‑Chain Data Access for Next‑Generation DeFi Interfaces',
      subtitle: 'Leveraging NLP and Blockchain Data Streaming to Deliver Instant, Context‑Aware Financial Insights and Actions',
      date:     '2025.04.12',
      img:      defiImg,
      link:     '/b2b/use-cases/defi'
    },
    {
      id:       'realestate',
      title:    'AI‑Powered Personalized Real Estate Report Generator Based on User‑Provided Property Data',
      subtitle: 'Transforming Detailed Property Inputs into Actionable, Intelligent Real Estate Reports with Conversational AI Assistance',
      date:     '2025.04.19',
      img:      realEstateImg,
      link:     '/b2b/use-cases/realestate'
    },
  ];

  return (
    <div className="usecases-container">
      <h1 className="usecases-heading">Powered by Us: B2B Collaborations</h1>

      <div className="usecase-grid">
        {placeholderCases.map((uc) => (
          <div key={uc.id} className="usecase-card placeholder">
            <img src={uc.img} alt={uc.title} className="card-img" />
            <div className="placeholder-label">Will be Updated Soon</div>
          </div>
        ))}
      </div>

      <h2 className="usecases-subheading">Latest Use Cases</h2>

      <div className="usecase-grid">
        {actualCases.map((uc) => (
          <Link to={uc.link} key={uc.id} className="usecase-card actual">
            <img src={uc.img} alt={uc.title} className="card-img" />
            <div className="card-content">
              <h3 className="card-title">{uc.title}</h3>
              <p className="card-subtitle">{uc.subtitle}</p>
              <span className="card-date">{uc.date}</span>
            </div>
            <div className="view-details">
              View Details&nbsp;→
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
